import { Box, useTheme } from "@mui/material";
import CustomTabPanel from "components/supplyAndDemand/Tabs/customTabPanel";
import Users from "pages/userManagement/users";
import PropTypes from "prop-types";
import { useStyles } from "./styles";
import Roles from "pages/userManagement/roles";
import { useParams } from "react-router-dom";
import Permissions from "pages/userManagement/permissions";
import Suppliers from "pages/userManagement/suppliers";

export const UserManagementPanels = ({ value, isNavbarOpen }) => {
  const theme = useTheme();
  const classes = useStyles({ theme, isNavbarOpen });
  let { id } = useParams();

  const urlToValueMap = {
    users: 0,
    roles: 1,
    permissions: 2,
    suppliers: 3,
  };

  const activeValue =
    value !== undefined ? value : Number(urlToValueMap[id]) || 0;

  return (
    <Box className={classes.settingsPanel}>
      <CustomTabPanel value={activeValue} index={0}>
        <Users isNavbarOpen={isNavbarOpen} />
      </CustomTabPanel>
      <CustomTabPanel value={activeValue} index={1}>
        <Roles isNavbarOpen={isNavbarOpen} />
      </CustomTabPanel>
      <CustomTabPanel value={activeValue} index={2}>
        <Permissions isNavbarOpen={isNavbarOpen} />
      </CustomTabPanel>
      <CustomTabPanel value={activeValue} index={3}>
        <Suppliers isNavbarOpen={isNavbarOpen} />
      </CustomTabPanel>
    </Box>
  );
};

export default UserManagementPanels;

UserManagementPanels.propTypes = {
  value: PropTypes.number,
  isNavbarOpen: PropTypes.bool.isRequired,
};
